<template>
  <modal name="loyaltyTermsAndConditionsModal">
    <loyalty-terms-and-conditions />
  </modal>
</template>


<script>
  import LoyaltyTermsAndConditions from './loyalty-terms-and-conditions/index.vue';


  export default {
    name: 'LoyaltyTermsAndConditionsModal',

    components: {
      LoyaltyTermsAndConditions
    }
  };
</script>
